import { Component, OnInit, ViewChild } from '@angular/core';
import { SiteService, CommonService } from 'src/app/services/index';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { MeterModel } from 'src/app/models/index';
import * as moment from 'moment';
import { DataService } from 'src/app/services/data.service';
import { AlertService, Constants } from 'src/app/shared/index';
import { MatDialog } from '@angular/material';
import { WarningDialog } from 'src/app/shared/index';
@Component({
  selector: 'app-manage-report',
  templateUrl: './manage-report.component.html',
  styleUrls: ['./manage-report.component.scss']
})
export class ManageReportComponent implements OnInit {
  siteId: string;
  selectedSite: string;
  sites: any;
  exportDataForm: FormGroup;
  displayAllSiteID: boolean;
  date = new FormControl(new Date());
  startView = 'month';
  max = new Date();
  constructor(private siteService: SiteService, private commonService: CommonService,
    private dataService: DataService, private fb: FormBuilder, private alertService: AlertService, private dialog: MatDialog) {
    this.exportDataForm = this.fb.group({
      siteCtr: ['', [Validators.required]],
      // dateCtr: []
    });
  }

  ngOnInit() {
    this.getSiteDetails();
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.displayAllSiteID = true;
    }
  }
  getSiteDetails() {
    this.siteService.getSiteDetails().subscribe(data => {
      this.sites = data;
    });
  }
  regenrate() {
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.selectedSite = this.siteId;
    }
    const date = moment(this.date.value).format('YYYY-MM-DD');
    const url = this.commonService.getGenerateManageReport(this.selectedSite, date);
    this.showReport(url);
  }

  send() {
    const seft = this;
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.selectedSite = this.siteId;
    }
    const date = moment(this.date.value).format('YYYY-MM-DD');
    // const url = this.commonService.getGenerateTriggerMail(this.selectedSite, date);
    // this.showReport(url);
    this.siteService.getGenerateTriggerMail(this.selectedSite, date).subscribe(data => {
      if (data) {
        seft.showMessage(data.data, 'Bosch-Ic-information');
      }
    });
  }

  showReport(url) {
    this.dataService.getPDF(url, true).subscribe((response) => {
      if (response.byteLength > 0) {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
      } else {
        this.alertService.message = 'No data response !';
        this.alertService.showError();
      }

    });
  }
  showMessage(msg, newIconClass) {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = msg;
    dialogRef.componentInstance.newIconClass = newIconClass;

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {

      }
    });
  }
}
